<app-aside-nav></app-aside-nav>

<app-header-nav></app-header-nav>
<router-outlet></router-outlet>
<telephony-main *ngIf="isTelephonyModule"></telephony-main>
